import * as React from "react";
import { hydrateRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { VideoContainer } from "../containers/Video";
import Footer from "../components/footer/Footer";

import "ms.geoip"; // Needed for personalization GTM pixel call tracking
import createAppStore from "../createAppStore";
import { Language, getLocalizer } from "../lang/Locale";

import NavComponent from "../components/nav/Nav";

const preloadedState = window.__PRELOADED_STATE__;
const preloadedStateNav = window.__PRELOADED_STATE_NAV__;

const store = createAppStore(preloadedState);

hydrateRoot(
    document.getElementById("nav-container") as Element,
    <NavComponent {...preloadedStateNav} />
);
hydrateRoot(
    document.getElementById("video-content") as Element,
    <Provider store={store}>
        <VideoContainer localizer={getLocalizer(Language.EN)} />
    </Provider>
);
hydrateRoot(document.getElementById("footer-container") as Element, <Footer />);

// trigger initial page view tracking
window.dataLayer.push({ event: "gtm.js" });
